import { render, staticRenderFns } from "./searchCert.vue?vue&type=template&id=25be82b6&scoped=true&"
import script from "./searchCert.vue?vue&type=script&lang=js&"
export * from "./searchCert.vue?vue&type=script&lang=js&"
import style0 from "./searchCert.vue?vue&type=style&index=0&id=25be82b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be82b6",
  null
  
)

export default component.exports